<template>
  <div class="dashboard-no-credit">
    <div class="no-credit-header">
      <i class="icon dashboard--no-pv"></i>
      <h2 v-html="$t('dashboard.noCredit.title')"></h2>
    </div>
    <div class="no-credit-body">
      <div class="exhaustion-date"
           v-if="pvExhaustionDate">
        <h3 v-html="$t('dashboard.noCredit.pvExhaustionDate')"></h3>
        <p>{{ pvExhaustionDate }}</p>
      </div>
      <p class="description d1" v-html="$t('dashboard.noCredit.description1')"></p>
    </div>
    <div class="no-credit-footer">
      <ui-button @click="$emit('onClose')">
        {{ $t('common.close') }}
      </ui-button>

      <ui-button class="charge-pv"
                 :backgroundColor="'#1199af'"
                 :primary4="true"
                 :iconName="'icon--pv-plug'"
                 @click="onChargePv">
        {{ $t('common.chargePv') }}
      </ui-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { format } from 'date-fns'
import UiButton from '@/components/ui/UiButton'

export default {
  name: 'DashboardNoPage',
  components: {
    UiButton
  },
  computed: {
    ...mapState([
      'userData'
    ]),
    pvExhaustionDate () {
      if (!this.userData.userCreditEmptyDate) {
        return false
      }
      return format(this.userData.userCreditEmptyDate, 'YYYY. MM. DD, HH:mm')
    }
  },
  methods: {
    onChargePv () {
      this.$router.push({ name: 'managePlan', params: { action: 'chargePv' } })
    }
  }
}
</script>

<style lang="scss">
.dashboard-no-credit {
  width: 640px;
  border-radius: 14px;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  text-align: center;

  .no-credit-header {
    padding-top: 50px;

    h2 {
      margin-top: 15px;
      font-size: 20px;
      font-weight: 500;
      color: #444444;
    }
  }

  .no-credit-body {
    padding-top: 5px;

    .exhaustion-date {
      width: 260px;
      border-radius: 5px;
      border: solid 1px #d7d7d7;
      background-color: #f4f4f4;
      margin: 20px auto;
      padding: 15px;

      h3 {
        font-size: 13px;
        font-weight: 500;
        color: #555555;
        margin-bottom: 5px;
      }

      p {
        font-size: 18px;
        font-weight: 500;
        color: #fc004e;
      }
    }

    .description {
      font-size: 14px;
      line-height: 1.57;
      margin: 10px 0;

      &.d1 {
        color: #fc004e;
      }

      &.d2 {
        color: #666666;
      }
    }
  }

  .no-credit-footer {
    padding: 40px 0 25px 0;

    .ui-btn {
      margin: 0 2px;
    }
  }
}
</style>
